import { COLORS } from "../../../constants";

export const surveyTypesConstants = {
  WIZARD: 0,
  QUESTIONNAIRE: 1,
  WIZARD_DESKTOP: 2,
};

export const fontFamilyStyles = [
  {
    name: "Times New Roman",
    value: "Times New Roman', Times, serif",
  },
  {
    name: "sans-serif",
    value: "sans-serif",
  },
  {
    name: "monospace",
    value: "monospace",
  },
  {
    name: "fantasy",
    value: "fantasy",
  },
  {
    name: "serif",
    value: "serif",
  },
  {
    name: "cursive",
    value: "cursive",
  },
];

export const themeSettingsConstants = {
  UPDATE_THEME: "UPDATE_THEME",
  EXISTING_THEME: "EXISTING_THEME",
  RESET_THEME: "RESET_THEME",
  DELETE_LOGO: "DELETE_LOGO",
};

export const themeSettingsLabels = {
  THEMES: "Themes",
  EXAMPLE: "Example",
  MAIN_THEME_COLOR: "Main Theme Color",
  PROGRESS_BAR_COLOR: "Progress Bar Color",
  FONT_COLOR: "Font Color",
  FONT_STYLE: "Font Style",
  STAR_COLOR: "Star Color",
  DELETE_LOGO_MESSAGE: "Are you sure you want to delete logo?",
};

export const themeLogoLimits = {
  MIN_WIDTH_PX: 1000,
  MIN_HEIGHT_PX: 500,
  PREVIEW_WIDTH_PX: 150,
  COLOR_MAX_LENGTH: 7,
  ACCEPTED_INPUT: "image/jpg,image/jpeg,image/png",
};

export const themeFontSelectStyles = {
  control: (styles) => ({
    ...styles,
    borderRadius: "4px",
    minHeight: "2.1rem",
    border: `1px solid ${COLORS.SILVER_GREY}`,
  }),
};

export const imageSizeAlert = {
  IMAGE_SIZE_ERROR: "Image size should not be smaller than 1000x500 pixels.",
  IMAGE_FORMAT_ERROR:
    "Please select a file with one of the following formats: JPG, JPEG, PNG.",
  IMAGE_FORMAT_ERROR_ALL_SUPPORTED:
    "Please select a file with one of the following formats: JPG, JPEG, PNG, SVG.",
  IMAGE_SIZE_ERROR_2MB: "Image size should not be greater than of 2MB.",
};

export const deviceSimulatorConstants = {
  IPHONE_X: "iPhone X",
  MACBOOK: "MacBook Pro",
};

export const surveyStylePreviewConstants = {
  EXPERIENCE_QUESTION: "How was your online ordering experience?",
  FILLED_STARS: "★★★★",
  EMPTY_STAR: "☆",
  PROGRESS_VALUE: 25,
  PROGRESS_MIN: 0,
  PROGRESS_MAX: 100,
  NO_DISPLAY: "No Display",
  LOGO_ALT: "Logo",
};

export const wizardDummyDataConstants = {
  CUSTOMER_NAME: "Jhon",
  EMAIL: "xyz@gmail.com",
  ORDER_ID: "123456",
};
